import { ComplexValue } from 'app/types-shared';
import { DashboardItem } from '../types-store';

const compareValues = (values: ComplexValue<number>[], originalValues: ComplexValue<number>[]): boolean => {
  const current = values || [];
  const original = originalValues || [];

  if (current.length !== original.length) {
    return true;
  }

  return current.some(
    value => !original.some(
      originalValue => value.value === originalValue.value
    ));
};

export const hasChanges = (item: DashboardItem, original: DashboardItem): boolean => {

  if (item?.id !== original?.id ||
    item?.disabled?.getTime() !== original?.disabled?.getTime() ||
    item?.sequence !== original?.sequence ||
    item?.accessType?.value !== original?.accessType?.value ||
    compareValues(item?.subset, original?.subset) ||
    compareValues(item?.application, original?.application) ||
    compareValues(item?.person, original?.person)) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};
